/* eslint-disable */

// Use this file to add the info button/modal to the fsp maps layers.
// To add a description create an object like the one below, with the exact name of the layer (case sensitive)
// Remember to use a full url, http://www.finmark.org.za/ and not www.finmark.org.za

// 'On-site ATM': {
//   'text': 'This is the text.',
//   'url': 'http://www.finmark.org.za/'
// }

export const LAYERS_INFO = {
};
